export default "__VITE_ASSET__CQjD8Qxg__"